import { useGroupTiming, useGroupTimestamps } from '@/entities/cues-group'
import { GroupRunState } from '@rundown-studio/utils'
import type { FC } from 'react'
import { CuesGroupActiveTiming } from './cues-group-active-timing'
import { CuesGroupActualTiming } from './cues-group-actual-timing'
import { useAtomValue } from 'jotai'
import { rundownAtom } from '../../../store/rundown.store'
import type { RundownCueOrderItem } from '@rundown-studio/types'

type CuesGroupActualTimingsWidgetProps = {
  childrenCues: RundownCueOrderItem[]
}

export const CuesGroupActualTimingsWidget: FC<
  CuesGroupActualTimingsWidgetProps
> = ({ childrenCues }) => {
  const rundown = useAtomValue(rundownAtom)
  const groupTimestamps = useGroupTimestamps(childrenCues)
  const groupTiming = useGroupTiming(groupTimestamps)

  // Determine if we should show actual timing
  // Show if: GROUP_PAST OR actual differs from original
  const shouldShowActualTiming =
    groupTiming &&
    (groupTiming.state === GroupRunState.GROUP_PAST ||
      groupTiming.actualDiffersFromOriginal)

  if (groupTiming?.state === GroupRunState.GROUP_ACTIVE) {
    return (
      <CuesGroupActiveTiming
        groupTiming={groupTiming}
        timezone={rundown?.timezone}
        todDisplayFormat={rundown?.settings?.todDisplayFormat}
      />
    )
  }

  if (shouldShowActualTiming) {
    return (
      <CuesGroupActualTiming
        groupTiming={groupTiming}
        timezone={rundown?.timezone}
        todDisplayFormat={rundown?.settings?.todDisplayFormat}
      />
    )
  }

  return null
}
